// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { IEventDetailsModel } from "@vanmeter/App/Services/EventListService";
import { Draft } from "immer";

export type EventDetailsPageState = Readonly<{
    [key: string]: IEventDetailsModel;
}>;

const initialState: EventDetailsPageState = {};

const reducer = {
    "xEventDetailsPage/SetEvent": (
        draft: Draft<EventDetailsPageState>,
        action: { eventId: string; event: IEventDetailsModel },
    ) => {
        draft[action.eventId] = action.event;
    },
};

const xEventDetailsPage = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xEventDetailsPage = xEventDetailsPage;

export type xEventDetailsPageState = {
    xEventDetailsPage: EventDetailsPageState;
} & ApplicationState;

type EventDetailsPageReducers = {
    query: typeof xEventDetailsPage;
};

export type xEventDetailsPage = Parameters<EventDetailsPageReducers[keyof EventDetailsPageReducers]>[1] | AnyAction;
